"use strict";

require("./groups/CompanyGroupService.js");
require("./groups/CompanyGroupUserService.js");
require("./publications/CompanyPublicationService.js");
require("./publications/PublicationTypeaheadDirective.js");
require("./users/CompanyUserPermissionService.js");

function CompanyDefaultGroupCtrl(
  $scope,
  $stateParams,
  $state,
  $sce,
  members,
  growl,
  CompanyGroupService,
  CompanyGroupUserService,
  translations,
  publications,
  CompanyPublicationService,
  CompanyUserService,
  CompanyUserPermissionService
) {
  $scope.members = members;
  $scope.publications = publications;
  $scope.users = [];
  $scope.page = 1;
  $scope.more = false;
  if ($scope.publications.length === 21) {
    $scope.more = true;
  }
  $scope.pageMember = 1;
  $scope.moreMember = false;
  if ($scope.members.length === 21) {
    $scope.moreMember = true;
  }

  $scope.tabs = [
    {
      title: $sce.trustAsHtml(translations["members"]),
      content: "",
      template: "partials/company/settings/default-group/users.html",
      icon: "users"
    },
    {
      title: $sce.trustAsHtml(translations["customer-portals.documents"]),
      content: "",
      template: "partials/company/settings/default-group/documents.html",
      icon: "files-o"
    }
  ];

  $scope.tabs.activeTab = 0;
  $scope.addMember = function(user) {
    CompanyUserPermissionService.update(
      { companyId: $stateParams.companyId, userId: user.id },
      { CompanyShowGrouplessPublications: true }
    ).$promise.then(
      function() {
        $scope.members.push(user);
        growl.addSuccessMessage(translations["settings.save-group-success"]);
      },
      function() {
        growl.addErrorMessage(translations["settings.save-group-failure"]);
      }
    );
  };

  $scope.removeMember = function(user) {
    CompanyUserPermissionService.update(
      { companyId: $stateParams.companyId, userId: user.id },
      { CompanyShowGrouplessPublications: false }
    ).$promise.then(
      function() {
        $scope.members.splice($scope.members.indexOf(user), 1);
        growl.addSuccessMessage(
          translations["customer-portals.remove-member-success"]
        );
      },
      function() {
        growl.addErrorMessage(
          translations["customer-portals.remove-member-failure"]
        );
      }
    );
  };

  $scope.queryUsers = function(text) {
    return CompanyUserService.query({
      companyId: $stateParams.companyId,
      q: text,
      limit: 100
    }).$promise.then(function(u) {
      $scope.users = u.filter(function(u) {
        return !members.some(function(member) {
          return member.id === u.id;
        });
      });
    });
  };

  $scope.queryMembers = function(pageMember) {
    $scope.pageMember = pageMember;
    return CompanyUserService.query({
      companyId: $stateParams.companyId,
      seeAllObjects: true,
      limit: 21,
      offset: ($scope.pageMember - 1) * 20
    }).$promise.then(function(members) {
      $scope.members = members;
      if ($scope.members.length === 21) {
        $scope.moreMember = true;
      } else {
        $scope.moreMember = false;
      }
    });
  };

  $scope.queryPublications = function(page) {
    $scope.page = page;
    return CompanyPublicationService.query({
      companyId: $stateParams.companyId,
      limit: 21,
      offset: ($scope.page - 1) * 20
    }).$promise.then(function(pulications) {
      $scope.publications = pulications;
      if ($scope.publications.length === 21) {
        $scope.more = true;
      } else {
        $scope.more = false;
      }
    });
  };
}

CompanyDefaultGroupCtrl.resolve = {
  members: [
    "$stateParams",
    "CompanyUserService",
    function($stateParams, CompanyUserService) {
      return CompanyUserService.query({
        companyId: $stateParams.companyId,
        seeAllObjects: true,
        limit: 21
      }).$promise;
    }
  ],
  translations: [
    "$translate",
    function($translate) {
      return $translate([
        "customer-portals.add-member-success",
        "customer-portals.add-member-failure",
        "customer-portals.remove-member-success",
        "customer-portals.remove-member-failure",
        "settings.save-group-success",
        "settings.save-group-failure",
        "members",
        "customer-portals.documents",
        "publication.remove-success",
        "publication.remove-failure"
      ]);
    }
  ],
  publications: [
    "$stateParams",
    "CompanyPublicationService",
    function($stateParams, CompanyPublicationService) {
      return CompanyPublicationService.query({
        companyId: $stateParams.companyId,
        limit: 21
      }).$promise;
    }
  ]
};

module.exports = CompanyDefaultGroupCtrl;

angular
  .module("dokiv")
  .controller("CompanyDefaultGroupCtrl", [
    "$scope",
    "$stateParams",
    "$state",
    "$sce",
    "members",
    "growl",
    "CompanyGroupService",
    "CompanyGroupUserService",
    "translations",
    "publications",
    "CompanyPublicationService",
    "CompanyUserService",
    "CompanyUserPermissionService",
    CompanyDefaultGroupCtrl
  ]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/CompanyDefaultGroupCtrl.js
// module id = 310
// module chunks = 0